import GradientIcon, { IGradientIcon } from './GradientIcon'
import { CBVThemes, getHexCodesFromCBVTheme } from './utils/cbvThemes'
import CBVRandomThemeIcon from 'assets/CBVRandomThemeIcon.svg?react'

import tailwind from '_/tailwind.config'

interface ICBVThemeIcon extends Omit<IGradientIcon, 'hexCodes'> {
  themeName: CBVThemes
}

const CBVThemeIcon = ({
  themeName,
  className = 'h-5 w-5 rounded',
  range = 4
}: ICBVThemeIcon) => {
  if (themeName === 'random') {
    return <RandomThemeIcon className={className} />
  }

  return (
    <GradientIcon
      className={className}
      hexCodes={getHexCodesFromCBVTheme(themeName)}
      range={range}
    />
  )
}

const RandomThemeIcon = ({ className }: { className: string }) => {
  return (
    <div
      className={`bg-gray-100 ${className}`}
      style={{ fill: tailwind.theme.colors.gray[500] }}
    >
      <CBVRandomThemeIcon />
    </div>
  )
}

export default CBVThemeIcon
